import { render, staticRenderFns } from "./draft_edit.vue?vue&type=template&id=4967158e&scoped=true&"
import script from "./draft_edit.vue?vue&type=script&lang=js&"
export * from "./draft_edit.vue?vue&type=script&lang=js&"
import style0 from "./draft_edit.vue?vue&type=style&index=0&id=4967158e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4967158e",
  null
  
)

export default component.exports